module.exports = __webpack_public_path__ + "img/jishui.5fca0bbf.png";